import { ApplicationRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, first } from 'rxjs';
import { LanguageService } from './core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { IdentityService } from './services/authentication/identity.service';
import { AuthenticationService } from './services/authentication/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'magiis';
  constructor(
    private router: Router,
    private languageService: LanguageService,
    private _translateService: TranslateService,
    private _identityService: IdentityService,
    private appRef: ApplicationRef,
    private authenticationService: AuthenticationService
  ) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        // Esperar hasta que Angular esté estable luego de navegar
        this.appRef.isStable.pipe(first(stable => stable))
          .subscribe(() => setTimeout(() => this.reapplyLanguage(), 3000));
      });
    // this.router.events
    // .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    // .subscribe(() => {
    //   // Espera un tick de JS para que termine la navegación/render
    //   setTimeout(() => this.reapplyLanguage(), 2000);
    // });

  }

  async ngOnInit(): Promise<void> {
    console.log('aca');
    // await this.authenticationService.updateFirebaseToken();
  }

  private reapplyLanguage(): void {
    // Tomá el idioma actual ya seleccionado
    const rawLang =
      this._identityService.defaultLanguage ||
      this._translateService.currentLang ||
      'en-us';

    // Normalize to a supported locale (browser may return 'en' or 'es', but
    // only 'en-us' and 'es-ar' locale files exist).
    const supportedLangs = ['en-us', 'es-ar', 'ar', 'ch', 'de', 'fr', 'it', 'ru'];
    const lang = supportedLangs.includes(rawLang)
      ? rawLang
      : (rawLang === 'es' ? 'es-ar' : 'en-us');

    // === EXACTAMENTE TU BLOQUE ===
    this.languageService.setLanguage(lang);
    this._translateService.use(lang);
    this._identityService.defaultLanguage = lang;

    const iframes = document.getElementsByTagName('iframe');
    for (let index = 0; index < iframes.length; index++) {
      const iframe = iframes.item(index);
      if (iframe && iframe.contentWindow && iframe.src.includes('external')) {
        iframe.contentWindow.postMessage({ setLanguage: lang }, '*');
      }
    }
    // =============================
  }
}
